import { Table, TableColumnsType } from 'antd'
import React from 'react'

import {
  IProductDailyItemsDetailsReport,
  IProductDailyItemsReport,
} from '../../../../../types/report'
import { Typography } from '@mui/material'

interface IDateDistributionTable {
  data?: IProductDailyItemsReport[]
  type?: string
}

const DateDistributionTable = (props: IDateDistributionTable) => {
  const { data, type = 'category' } = props
  const expandedRowRender = (
    record: IProductDailyItemsReport & { key: number },
  ) => {
    let nameColumn = {
      title: 'ชื่อหมวดหมู่',
      dataIndex: 'categoryName',
      key: 'categoryName',
      align: 'center' as const,
      render: (categoryName: string) => (
        <Typography variant="subtitle2" color="text.secondary" minWidth={100}>
          {categoryName}
        </Typography>
      ),
    }

    if (type === 'product') {
      nameColumn = {
        title: 'ชื่อสินค้า',
        dataIndex: 'productName',
        key: 'productName',
        align: 'center' as const,
        render: (productName: string) => (
          <Typography variant="subtitle2" color="text.secondary" minWidth={100}>
            {productName}
          </Typography>
        ),
      }
    }

    const columns: TableColumnsType<IProductDailyItemsDetailsReport> = [
      {
        ...nameColumn,
      },
      // {
      //   title: 'ชื่อหมวดหมู่',
      //   dataIndex: 'categoryName',
      //   key: 'categoryName',
      //   align: 'center' as const,
      //   render: (categoryName: string) => (
      //     <Typography variant="subtitle2" color="text.secondary" minWidth={100}>
      //       {categoryName}
      //     </Typography>
      //   ),
      // },
      {
        title: 'จำนวน',
        dataIndex: 'quantity',
        key: 'quantity',
        align: 'center' as const,
        render: (quantity: string) => (
          <Typography variant="subtitle2" color="text.secondary" minWidth={90}>
            {quantity}
          </Typography>
        ),
      },
      {
        title: 'COD',
        dataIndex: 'codTotal',
        key: 'codTotal',
        align: 'center' as const,
        render: (codTotal: string) => (
          <Typography variant="subtitle2" color="text.secondary" minWidth={90}>
            {codTotal}
          </Typography>
        ),
      },
      {
        title: 'BANK',
        dataIndex: 'bankTotal',
        key: 'bankTotal',
        align: 'center' as const,
        render: (center: string) => (
          <Typography variant="subtitle2" color="text.secondary" minWidth={90}>
            {center}
          </Typography>
        ),
      },
    ]
    return (
      <Table
        columns={columns}
        scroll={{
          x: columns.reduce(
            (pre, cur: any) => (cur.width ? cur.width + pre : pre),
            0,
          ),
        }}
        dataSource={record.items}
        pagination={false}
      />
    )
  }

  const columns: TableColumnsType<IProductDailyItemsReport & { key: number }> =
    [{ title: 'วันที่', dataIndex: 'date', key: 'date' }]

  return (
    <>
      <Table
        columns={columns}
        expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
        scroll={{
          x: columns.reduce(
            (pre, cur: any) => (cur.width ? cur.width + pre : pre),
            0,
          ),
        }}
        dataSource={
          data?.map((item: IProductDailyItemsReport, index: number) => ({
            ...item,
            key: index,
          })) ?? []
        }
        size="middle"
      />
    </>
  )
}

export default DateDistributionTable
